import { render, staticRenderFns } from "./tween-input-text.vue?vue&type=template&id=4708a48c&scoped=true&"
import script from "./tween-input-text.vue?vue&type=script&lang=js&"
export * from "./tween-input-text.vue?vue&type=script&lang=js&"
import style0 from "./tween-input-text.vue?vue&type=style&index=0&id=4708a48c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4708a48c",
  null
  
)

export default component.exports